import { useContext } from 'react';
import { PaymentMethodContextType } from './PaymentMethodContextTypes';
import { PaymentMethodContext } from './PaymentMethodContext';

export function usePaymentMethodContext() {
  return useContext<PaymentMethodContextType | null>(
    PaymentMethodContext
  ) as PaymentMethodContextType;
}
